import { AiOutlineClose } from 'react-icons/ai';

const ModalBox = ({
  id,
  header,
  content,
  footer,
  customclass = '',
  icon,
  iconclick,
  iconposition = 'left',
  iconclass = ''
}) => {
  return (
    <div
      className={'modal fade ' + customclass}
      id={id}
      data-bs-backdrop='static'
      data-bs-keyboard='false'
      tabIndex='-1'
      aria-labelledby={id + 'Label'}
      aria-hidden='true'
    >
      <div className='modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg'>
        <div className='modal-content'>
          {header && (
            <div className='modal-header'>
              {/* Icon Display */}
              {icon && iconposition === 'left' && (
                <div className={`icon ${iconclass}`} onClick={iconclick}>
                  {icon}
                </div>
              )}
              <h1 className='modal-title fs-5' id={id + 'Label'}>
                {header}
              </h1>
              {/* Icon Display */}
              {icon && iconposition !== 'left' && (
                <div className={`icon ${iconclass}`} onClick={iconclick}>
                  {icon}
                </div>
              )}
              <div
                style={{ cursor: 'pointer' }}
                data-bs-dismiss='modal'
                aria-label='Close'
              >
                <AiOutlineClose />
              </div>
            </div>
          )}
          {content && <div className='modal-body'>{content}</div>}
          {footer && (
            <div className='modal-footer'>
              <button
                type='button'
                className='btn btn-primary'
                data-bs-dismiss='modal'
              >
                Close
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ModalBox;
